import { render } from "./registration-form.vue?vue&type=template&id=05ec2193"
import script from "./registration-form.vue?vue&type=script&lang=js"
export * from "./registration-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__